module.exports = __webpack_public_path__ + "img/button_next_bottom_active.b25db0c4.svg";